import React from "react";
import SvgIcon from "../../parts/SvgIcon";

const IconsList = ({ icons }) => {
  return (
    <div className="docs-iconslist flex flex-wrap gap-5 justify-between">
      {icons.map((icon) =>
        icon.endsWith(".gz") ? null : (
          <article className="flex flex-col items-center gap-2 ">
            <SvgIcon
              src={`/img/new-icons/${icon}`}
              noFilterOnLight={true}
              className="w-full h-full text-center"
            />
            <span>{icon}</span>
          </article>
        )
      )}
    </div>
  );
};

export default IconsList;
